import angular from 'angular';

angular.module('cloudX').controller('FlyCtrl', ['$scope', 'flySvc', FlyCtrl]);

function FlyCtrl($scope, flySvc) {
  var vm = this;
  vm.flyArray = flySvc.getFlyArray();
}
